/** Mirror of B2B_BACK_END/src/constants/platformNotification.ts */

export const PLATFORM_NOTIFICATION_MODULES = [
  "marketplace",
  "procurement",
  "quality_inspection",
  "logistics",
  "contract_manufacturing",
  "infrastructure",
  "auction",
  "approval",
  "payment",
  "general",
];

export const PLATFORM_MODULE_LABELS = {
  marketplace: "Marketplace",
  procurement: "Procurement",
  quality_inspection: "Quality Inspection",
  logistics: "Logistics",
  contract_manufacturing: "Contract Manufacturing",
  infrastructure: "Infrastructure Leasing",
  auction: "Auction",
  approval: "Approval",
  payment: "Payment",
  general: "General",
};

export const labelForModule = (moduleName) =>
  PLATFORM_MODULE_LABELS[moduleName] || moduleName || "General";

export const PLATFORM_NOTIFICATIONS_REFRESH_EVENT = "platform-notifications-refresh";

export function dispatchPlatformNotificationsRefresh() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(PLATFORM_NOTIFICATIONS_REFRESH_EVENT));
  }
}
